module.exports = __webpack_public_path__ + "img/blue-bg.8097527c.jpeg";